<template>
    <common-icon v-if="showBadge" class="verify-badge" name="verified" :size="size"></common-icon>
</template>

<script>
    export default {
        props: {
            user: { type: Object, default: undefined },
            size: { type: String, default: 'tiny' },
        },

        computed: {
            showBadge() {
                return this.user && this.user?.mobile?.length
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';

    .verify-badge {
        color: $color--accent-12;
    }
</style>
